import { ItemConfig } from './types'

const CM_PX = 78.7
const STANDARD_WIDTH = 8000
const front_anchor = STANDARD_WIDTH * 0.3
const back_anchor = STANDARD_WIDTH * 0.27

const SLEEVE_WIDTH = 5000
const SLEEVE_HEIGHT = 4300
const sleeve_anchor = SLEEVE_HEIGHT - 5 * CM_PX

const sizes = {
  S: 0.846,
  M: 0.897,
  L: 0.948,
  XL: 1,
}

export const PARKER_CONFIG: ItemConfig = {
  name: 'Printstar 8.4oz フーデッドライトパーカー',
  vendor: 'トムス',
  vendor_code: '216-MLH',
  printable_sections: ['103', '105'],
  colors: [
    { name: 'ホワイト', system_id: '001', hex: '#ffffff' },
    { name: 'ブラック', system_id: '005', hex: '#000000' },
  ],
  sizes: ['S', 'M', 'L', 'XL'],
  sections: [
    {
      name: '胸中央',
      id: '103',
      config: {
        width: 2115,
        height: 1574,
      },
    },
    {
      name: '右胸',
      id: '102',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '左胸',
      id: '101',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '背中中央',
      id: '105',
      config: {
        width: 2518,
        height: 2991,
      },
    },
    {
      name: '襟下',
      id: '109',
      config: {
        width: 787,
        height: 787,
      },
    },
    {
      name: '左長袖',
      id: '252',
      config: {
        width: 787,
        height: 2756,
      },
    },
    {
      name: '右長袖',
      id: '253',
      config: {
        width: 787,
        height: 2756,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: STANDARD_WIDTH,
      height: STANDARD_WIDTH,
      origin: { x: STANDARD_WIDTH / 2, y: front_anchor },
      sizes,
      sections: [
        {
          id: '103',
          offset: {
            y: CM_PX * 7,
            x: -(2115 / 2),
          },
        },
        {
          id: '101',
          offset: {
            x: 5 * CM_PX,
            y: 6 * CM_PX,
          },
        },
        {
          id: '102',
          offset: {
            y: 6 * CM_PX,
            x: -(5 * CM_PX + 787),
          },
        },
      ],
    },
    {
      name: 'back',
      width: STANDARD_WIDTH,
      height: STANDARD_WIDTH,
      origin: { x: STANDARD_WIDTH / 2, y: back_anchor },
      sizes,
      sections: [
        {
          id: '105',
          offset: {
            x: -(2518 / 2),
            y: 9 * CM_PX,
          },
        },
        {
          id: '109',
          offset: {
            x: -(787 / 2),
            y: 2.5 * CM_PX,
          },
        },
      ],
    },
    {
      name: 'left',
      width: SLEEVE_WIDTH,
      height: SLEEVE_HEIGHT,
      origin: { x: SLEEVE_WIDTH / 2, y: sleeve_anchor },
      sizes,
      sections: [
        {
          id: '252',
          offset: {
            y: -(2756 + 5 * CM_PX),
            x: -787 / 2,
          },
        },
      ],
    },
    {
      name: 'right',
      width: SLEEVE_WIDTH,
      height: SLEEVE_HEIGHT,
      origin: { x: SLEEVE_WIDTH / 2, y: sleeve_anchor },
      sizes,
      sections: [
        {
          id: '253',
          offset: {
            y: -(2756 + 5 * CM_PX),
            x: -787 / 2,
          },
        },
      ],
    },
  ],
}
